'use strict'

export const Table = {}
